module.exports = __webpack_public_path__ + "static/media/icon_input_search.b56edaac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_input_search.svg
// module id = 262
// module chunks = 0